import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './layout.component';

const routes: Routes = [
    {
        path: '',
        component: LayoutComponent,
        children: [
            {
                path: 'main',
                loadChildren: () =>
                    import('../../main/main.module').then((m) => m.MainModule),
            },
            {
                path: 'admin',
                loadChildren: () =>
                    import('../../admin/admin.module').then(
                        (m) => m.AdminModule
                    ),
            },
            {
                path: '',
                redirectTo: 'main',
                pathMatch: 'full',
            },
            {
                path: '**',
                redirectTo: 'error/404',
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class PagesRoutingModule { }
